import cn from 'classnames'
import { ReactNode, CSSProperties } from 'react'

interface IRow {
  children: ReactNode
  className?: string
  style?: CSSProperties
  row?: 10 | 15 | 16 | 20 | 30 | 40
  align?: 'start' | 'center' | 'end'
  justify?: 'start' | 'center' | 'end' | 'space-between'
}

const Row = ({ children, className, style, row, align, justify }: IRow) => {
  const classList = cn(
    'row',
    {
      [`row-${row}`]: row,
      [`align-items-${align}`]: align,
      [`justify-content-${justify}`]: justify
    },
    className
  )

  return (
    <div className={classList} style={style}>
      {children}
    </div>
  )
}

export default Row
